import { createNamespacedHelpers } from 'vuex';

const { mapState } = createNamespacedHelpers('pokerChipCalcModule');

export default {
    computed: {
        ...mapState(['cssClasses']),
    }
}
